import BaseForm from '../base';
import { LatLongColumnsComponent, secondsFieldStoredAsMilliseconds } from '../components';
const GPS_TYPE_DESC = 'Selects how the position is read. Serial and TCP both speak NMEA; Starlink ' +
    'reads the dish over its local gRPC API and needs Location Request Mode = Local ' +
    'on the dish, plus a service plan that exposes local GPS.';
// Intentionally no `onlyAvailableItems` validation: equipment in the field
// predates this list (values such as `bu353` and `edge` are in use), and
// rejecting an unlisted value would make existing equipment un-editable. Only
// `starlink` changes behaviour on the device; anything else is treated as NMEA.
const GPS_TYPES = [
    {
        label: 'Serial (NMEA)',
        value: 'serial'
    },
    {
        label: 'TCP (NMEA)',
        value: 'tcp-nmea'
    },
    {
        label: 'Starlink dish',
        value: 'starlink'
    },
    {
        label: 'BU-353 (legacy, serial)',
        value: 'bu353'
    },
    {
        label: 'Edge gateway (legacy, TCP)',
        value: 'edge'
    },
];
export class GpsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'GPS Type',
                key: 'gpsType',
                type: 'select',
                data: { values: GPS_TYPES },
                description: GPS_TYPE_DESC,
                searchFields: ['label', 'value'],
                validate: { required: true },
            },
            {
                label: 'Device',
                key: 'device',
                type: 'textfield',
                placeholder: '/dev/ttyPCUSB0',
                description: 'Serial receivers only.',
            },
            {
                label: 'IP',
                key: 'ip',
                type: 'textfield',
                description: 'TCP NMEA and Starlink. A Starlink dish is normally 192.168.100.1.',
            },
            {
                label: 'Port',
                key: 'port',
                type: 'number',
                description: 'For TCP NMEA and Starlink. Leave empty for the Starlink default (9200).',
            },
            ...secondsFieldStoredAsMilliseconds({
                msKey: 'updateRateMilliseconds',
                secondsKey: 'reportingIntervalSeconds',
                label: 'Reporting interval (seconds)',
                description: 'How often the device reports its position. Saved as milliseconds.',
                defaultSeconds: 60,
                min: 1,
                max: 86400,
            }),
            {
                label: 'Max Accuracy (m)',
                key: 'maxSigmaMeters',
                type: 'number',
                description: 'Reject positions coarser than this. A dish reporting 0 means ' +
                    '"not reported" and is accepted rather than treated as perfect accuracy. ' +
                    'Starlink typically reports around 25m.',
                conditional: {
                    show: true,
                    when: 'gpsType',
                    eq: 'starlink',
                },
            },
            {
                label: 'Minimum Movement (m)',
                key: 'minMoveMeters',
                type: 'number',
                description: 'Skip an update that has not moved at least this far. Leave empty ' +
                    'to report on every interval. Recommended for a fixed Starlink site, which ' +
                    'repeats an identical position on every poll; leave empty for a tracker ' +
                    'where every point matters.',
            },
            {
                label: 'Heartbeat (ms)',
                key: 'heartbeatMs',
                type: 'number',
                description: 'With Minimum Movement set, still report this often so a ' +
                    'stationary asset is not mistaken for a dead one.',
            },
            {
                label: 'Trail color',
                key: 'color',
                type: 'textfield',
                placeholder: '#1E90FF',
                description: "Hex color for this unit's trail and stops on the map " +
                    '(e.g. #1E90FF). Leave empty to auto-assign a color.',
                validate: { pattern: '^#[0-9a-fA-F]{6}$' },
            },
        ];
    }
}
